'use client'
import React, { useState } from 'react'
import dynamic from 'next/dynamic'

const ModalDialog = dynamic(() =>
  import('@dustin-web/microsite-components/src/modal-dialog').then(mod => mod.ModalDialog)
)
const ModalContent = dynamic(
  () => import('@productsite-beta/src/components/product-slider/product-slider-modal-content')
)
const ProductSingleImage = dynamic(
  () => import('@productsite-beta/src/components/product-slider/product-slider-single-image')
)

import ImageCarousel from '@dustin-web/microsite-components/src/image-carousel'
import { ProductPageType } from '../product-page'
type Props = {
  product: ProductPageType
}

export default function ProductSlider({ product }: Props) {
  const [showModal, setShowModal] = useState(false)
  const [initialSlide, setInitialSlide] = useState(0)
  const imageIds = product.pageDisplayData?.imageIds || []
  return (
    <>
      {imageIds.length > 1 ? (
        <ImageCarousel
          imageSliderProps={{ maxHeight: '700px' }}
          imageIds={imageIds}
          slugText={product.fullDisplayName}
          setShowModal={slide => {
            setShowModal(true)
            setInitialSlide(slide)
          }}
        />
      ) : (
        <ProductSingleImage
          imageId={imageIds[0]}
          slugText={product.fullDisplayName}
          toggleModal={() => setShowModal(true)}
        />
      )}

      <ModalDialog
        ariaLabel={`Images of the product ${product.displayName}`}
        show={showModal}
        fullscreen
        handleClose={() => setShowModal(false)}
        disableFocusLock>
        <ModalContent
          imageIds={imageIds}
          slugText={product.fullDisplayName}
          initialSlide={initialSlide}
        />
      </ModalDialog>
    </>
  )
}
